const DailyMealsReleases = () => import("./views/DailyMealsReleases.vue");
const DailyMealsReleasesEdit = () => import("./views/DailyMealsReleasesEdit.vue");

const route = "/dailyMealsReleases";

export default [
  {
    path: route,
    name: "dailyMealsReleases.list",
    component: DailyMealsReleases,

    meta: {
      roles: ["ROLE_ADMIN"],
    },
  },

  {
    path: `${route}/create`,
    name: "dailyMealsReleases.create",
    component: DailyMealsReleasesEdit,

    meta: {
      roles: ["ROLE_ADMIN"],
    },
  },
];
